/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BatchGenerateAchievementHtmlRequest } from '../../models/batch-generate-achievement-html-request';
import { BatchGenerateAchievementHtmlResponse } from '../../models/batch-generate-achievement-html-response';

export interface AchievementServiceBatchGenerateAchievementHtml$Params {
      body: BatchGenerateAchievementHtmlRequest
}

export function achievementServiceBatchGenerateAchievementHtml(http: HttpClient, rootUrl: string, params: AchievementServiceBatchGenerateAchievementHtml$Params, context?: HttpContext): Observable<StrictHttpResponse<BatchGenerateAchievementHtmlResponse>> {
  const rb = new RequestBuilder(rootUrl, achievementServiceBatchGenerateAchievementHtml.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BatchGenerateAchievementHtmlResponse>;
    })
  );
}

achievementServiceBatchGenerateAchievementHtml.PATH = '/api/v3/gateway/htmlgen/achievement/batch';
